
<div class="ipm-change-password-section">
    <div class="ipm-heading-model-section">
        <h3> {{ currentPopType === 'guest-change-password' ? 'Set Password' : (currentPopType === 'change-password' ? 'Change Password' : 'Reset Password') }}</h3>
        <div class="ipm-close-icon" (click)="closeByDeviceType()">
            <i class="pi-times pi"></i>
        </div>
    </div>
    <div class="ipm-change-password-body">
    <div class="error-message-data" *ngIf="shakeAnimation.errorMessage">
            {{shakeAnimation.errorMessage}}
        </div>
        <p class="ipm-sub-heading">
            {{ currentPopType === 'guest-change-password' ? 'Please set a password for your account.' : 'Please create a new password for your account.' }}
        </p>
        
        <ipm-login-signup [authType]="currentPopType" #changePasswordForm>
            <div class="ipm-actions" actions>        
                <button mat-flat-button 
                        color="primary"
                        class="primary-button ipm-submit-btn"
                        type="submit"
                        (click)='changePasswordApiCall(changePasswordForm.authForm)'
                        [disabled]="!changePasswordForm.authForm.valid">
                    {{ currentPopType === 'guest-change-password' ? 'Set Password' : (currentPopType === 'change-password' ? 'Change Password' : 'Reset Password') }}
                </button>
            </div>
        </ipm-login-signup>
    </div>
</div>

